/** @jsx jsx */
import { jsx, Flex } from "theme-ui"
import PropTypes from "prop-types"

import LinesIcon from "components/svgs/lines"

const Lines = ({ side }) => (
  <Flex
    sx={{ my: 6, justifyContent: side === "left" ? "flex-start" : "flex-end" }}
  >
    <LinesIcon flipX={side === "right"} />
  </Flex>
)

Lines.propTypes = {
  side: PropTypes.string.isRequired,
}

export default Lines
